<template>
  <v-navigation-drawer
    v-model="isOpen"
    :mini-variant="miniVariant"
    :permanent="permanent"
    app
  >
    <v-layout column fill-height justify-space-between>
      <v-list>
        <template v-for="item1 in items">
          <v-list-group
            v-if="item1.items"
            :key="item1.title"
            v-model="item1.active"
            :prepend-icon="item1.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile :to="item1.link">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item1.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="item2 in item1.items"
              :key="item2.title"
              :to="item2.link"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ item2.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item1.title" :to="item1.link">
            <v-list-tile-action>
              <v-icon color="black">{{ item1.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item1.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-flex class="flex-grow-0">
        <v-layout justify-center>
          <v-btn icon @click.stop="miniVariant = !miniVariant">
            <v-icon v-if="miniVariant">chevron_right</v-icon>
            <v-icon v-else>chevron_left</v-icon>
          </v-btn>
          <v-btn
            v-show="!miniVariant"
            icon
            @click.stop="permanent = !permanent"
          >
            <v-icon v-if="permanent">lock</v-icon>
            <v-icon v-else>lock_open</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LeftDrawer",
  data: () => ({
    drawer: false,
    permanent: false,
    items: [
      {
        action: "live_help",
        active: false,
        link: { name: "Types" },
        title: "Categories"
      }
    ],
    miniVariant: false
  }),
  computed: {
    ...mapGetters({
      leftDrawer: "ui/leftDrawer"
    }),
    isOpen: {
      get() {
        return this.leftDrawer;
      },
      set(val) {
        this.setLeftDrawer(val);
      }
    }
  },
  methods: {
    ...mapActions({
      setLeftDrawer: "ui/setLeftDrawer"
    })
  }
};
</script>
